@if (showNewItemSpotlight$ | async) {
  <bit-callout [title]="nudgeTitle" [icon]="null" (dismiss)="dismissNewItemSpotlight()">
    {{ nudgeBody }}
  </bit-callout>
}
